<template>
  <div class="Submenu">
    <template v-for="item in menuList" >
      <!-- 如果当前有子菜单，则显示 el-submenu ，在el-subment 里调用 递归组件 -->
      <el-submenu
        v-if="item.subCates && item.subCates.length > 0"
        :index="item.id"
        :key="item.id"
        @click="switchMenu(item.id)">
        <template slot="title">
          <span slot="title">
            {{ item.name }}
          </span>
        </template>
        <!-- 调用自身  此处是重点-->
        <Submenu :menuList="item.subCates"></Submenu>
      </el-submenu>
      <!-- 如果没有子菜单，则显示当前内容 -->
      <el-menu-item v-else :index="item.id" :key="item.id" @click="switchMenu(item.id)">
        <span v-show="item.subCates == undefined" class="iconfont icon-zuzhizhankai"></span>
        {{ item.name }}
      </el-menu-item>
    </template>
  </div>
</template>
<script>
export default {
  name: 'Submenu',
  data () {
    return {
    }
  },
  props: {
    menuList: {  // 在这里增加了引入校验，方便错误排除
      type: Array,
      required: false,
    },
  },
  methods: {
    switchMenu(e) {
      let id = e
      if(id == 100) {
        let url = this.$router.resolve({ path: "/cdgk", query: { id } });
        window.open(url.href,'_blank')
      }else if(id == 101) {
        let url = this.$router.resolve({ path: "/fzhj", query: { id } });
        window.open(url.href,'_blank')
      }else{
        let goUrl = this.$router.resolve({path:'/details',query: {id:id}})
        window.open(goUrl.href,'_blank')
      }

    },
  },
  created () {
  },
  mounted () {
  },
}
</script>
<style lang="less" >
.el-menu-item,
.el-submenu__title {
  font-size: 17px;
}
.el-menu-item:last-child {
  // margin-top: 15px;
  border-bottom: 1px solid #0086e3;
}
.el-submenu {
  border-top:1px solid #0086e3;
  border-left:1px solid #0086e3;
  border-right:1px solid #0086e3;
}
.el-submenu>ul>.Submenu>li {
  border: none;
  background-color: #0086e3;
}
</style>
